"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // this component wp-menu based on the minisite type.
// only creates the menu left side from logo
// minisite Types: 0 = lodging, 1 = own activities, 2 = area activites

var _module2 = require("../../module");

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var winresLogoController = function () {
    function winresLogoController(ownerService, $window, localizationService) {
        _classCallCheck(this, winresLogoController);

        this.ownerService = ownerService;
        this.$window = $window;
        this.localizationService = localizationService;
    }

    _createClass(winresLogoController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            this.path = this.$window.location.href;

            // create path that does not include current page.
            this.urlLength = this.path.includes(this.defaultAddress) ? 4 : 3;
            this.splitPath = this.path.split("/");
            this.homePath = "";
            for (var i = 0; i < this.urlLength; i++) {
                this.homePath = this.homePath + this.splitPath[i] + "/";
            }

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getOwnerData()

            this.winresReservationContext.getOwnerData().then(function (data) {
                _this.logo = data.LogoUrl;
                if (_this.whiteLoading === "true") {
                    try {
                        var whiteScreenB = setTimeout(function () {
                            return document.getElementById("white-loading-screen").style.display = "none";
                        }, 1000); // To fix possible error with angular.element
                        angular.element(document.querySelector('#white-loading-screen').style.display = "none");
                        clearTimeout(whiteScreenB);
                    } catch (e) {
                        console.error(e);
                    }
                }
            });

            if (this.localizationService.getLanguage() == 'fi') {
                this.home = '?lang=fi';
            } else if (this.localizationService.getLanguage() == 'en') {
                this.home = '?lang=en';
            }
        }
    }]);

    return winresLogoController;
}();

winresLogoController.$inject = ['ownerService', '$window', 'localizationService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl(getWebcomponentsUrl($attrs.templateUrl)) : 'winresLogo';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresLogo', require('./winresLogo.html'));
}]);

_module3.default.component('winresLogo', {
    templateUrl: getTemplate,
    controller: winresLogoController,
    bindings: {
        // this is the default address where minisites are by default.
        defaultAddress: '@',

        //removes a dom element with id "white-loading-screen" when the loading is done
        whiteLoading: '@'
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresLogo/winresLogo.js
// module id = 313
// module chunks = 2